import { generateColumnGroup } from 'features/company/Stream/TableOrderbook/utils';
import { OrderbookPriceData } from '../../../../../../@types/orderbook';

interface TableOrderbookItemSummaryProps {
  data: Array<OrderbookPriceData>;
  renderItemOrderbook: (props: Array<OrderbookPriceData>) => Array<JSX.Element>;
  renderOrderbookSummary: (props: Array<OrderbookPriceData>) => JSX.Element;
}

const TableOrderbookItemSummary = ({
  data,
  renderItemOrderbook,
  renderOrderbookSummary,
}: TableOrderbookItemSummaryProps) => (
  <table>
    <thead>{generateColumnGroup()}</thead>
    <tbody>{renderItemOrderbook(data)}</tbody>
    <tfoot>{renderOrderbookSummary(data)}</tfoot>
  </table>
);

export default TableOrderbookItemSummary;
